import styled from 'styled-components'
import { MediaElement } from '../../UI/MediaElement'

export const BlogMediaFigure = styled.figure`
  width: 100%;
  height: 100%;

  * {
    border-radius: 4px;
  }

  video,
  iframe {
    aspect-ratio: 16/9;
    border: 0;
    display: block;
    object-fit: cover;
    width: 100%;
  }
`
export const BlogMediaElement = styled(MediaElement)`
  width: 100%;
  margin: 0 auto;
  border-radius: 20px;
`
export const BlogMediaFooter = styled.figcaption`
  padding-inline: 1rem;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`
export const BlogMediaCaption = styled.span`
  color: ${({ theme }) => theme.colors.black[3]};
  font-size: 0.9rem;
  line-height: 1.35rem;
  text-align: center;
  font-weight: 400;
  flex: 1;
`

export const BlogMediaCopyright = styled.span`
  color: ${({ theme }) => theme.colors.black[4]};
  font-size: 0.7rem;
  line-height: 1.1;
  text-align: center;
  font-weight: 600;
`

export const BlogMediaWrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  max-width: 80vw;
  margin: 0 auto;
  border-radius: 1.5rem;
  height: max-content;
`
